import { render, staticRenderFns } from "./AddInboxes.vue?vue&type=template&id=68a38b7a&scoped=true&"
import script from "./AddInboxes.vue?vue&type=script&lang=js&"
export * from "./AddInboxes.vue?vue&type=script&lang=js&"
import style0 from "./AddInboxes.vue?vue&type=style&index=0&id=68a38b7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a38b7a",
  null
  
)

export default component.exports